// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as React from "react";
import {
    //Box, 
    TextField,
    Select,
    //MenuItem, 
    //InputLabel, 
    //FormControl, 
    //Checkbox,
    makeStyles
} from '@material-ui/core';
// import {
//     DatePicker,
//     DateTimePicker,
//     DateRangePicker,
//     DateTimeRangePicker
// } from "react-advance-jalaali-datepicker";
import DatePickerInput from '../Components/DatePickerInput'
import SearchBtn from '../Components/SearchBtn'

const useStyles = makeStyles((theme) => ({
    textField: {
        width: '25ch',
    },
}));

const paymentStatuses = [
    {
        value: 'None',
        label: 'همه',
    },
    {
        value: 'Created',
        label: 'ارسال پیامک',
    },
    {
        value: 'PaymentPending',
        label: 'منتظر پرداخت',
    },
    {
        value: 'PaymentSuccess',
        label: 'پرداخت موفق',
    },
    {
        value: 'PaymentFailure',
        label: 'پرداخت ناموفق',
    },
];

export default function OrderSearchPanel(props: any) {
    const classes = useStyles();
    const [orderStatuses, setOrderStatuses] = React.useState('PaymentSuccess');
    const [customer, setCustomer] = React.useState('')
    const [fromDate, setFromDate] = React.useState()
    const [toDate, setToDate] = React.useState()

    const handleSearch = () => {
        let searchObject = {};

        if (orderStatuses !== "None")
            searchObject.orderStatuses = { some: { status: orderStatuses } }
        //searchObject.orderStatuses = { some: { status: orderStatuses } }
        if (fromDate)
            searchObject.fromDate = { gte: fromDate }
        if (toDate)
            searchObject.toDate = { lte: toDate }
        if (customer)
            searchObject.lnCustomer = { path: ["lastName"], string_contains: customer }

        //setSearchValues({ ...searchValues, sex: gender })

        props.handleSearch(searchObject);
    }

    const handleChangeLastStatus = (event: any) => {
        setOrderStatuses(event.target.value);
    };


    return (
        <div dir="rtl" className="search-panel">

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '1rem' }}>
                <TextField
                    id="outlined-select-currency-native"
                    select
                    onChange={handleChangeLastStatus}
                    variant="outlined"
                    value={orderStatuses}
                    className={classes.textField}
                >
                    {paymentStatuses.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </TextField>

                <TextField
                    id="outlined-select-currency-native"
                    onChange={(e) => setCustomer(e.target.value)}
                    variant="outlined"
                    value={customer}
                    className={classes.textField}
                    placeholder="نام‌خانوادگی خریدار"
                >
                </TextField>

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ fontFamily: 'IranSans-Light', marginLeft: '0.5rem' }}>تاریخ به‌روزرسانی از</p>
                    <TextField
                        id="fromdate"
                        onChange={(e) => setFromDate(e.target.value)}
                        value={fromDate}
                        placeholder="تاریخ ایجاد از"
                        type="date"
                        variant="outlined"
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <p style={{ fontFamily: 'IranSans-Light', marginLeft: '0.5rem', marginRight: '0.5rem' }}>تا</p>
                    <TextField
                        id="todate"
                        onChange={(e) => setToDate(e.target.value)}
                        value={toDate}
                        placeholder="تاریخ ایجاد تا"
                        type="date"
                        variant="outlined"
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </div>

            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>

                <SearchBtn onClickCallback={handleSearch} label="جستجو" icon="SearchIcon" />
            </div>
        </div>
    )
}